import { API_URL } from '../config';

/**
 * A URL the browser can load: root-relative paths (`/assets/...`, served by the
 * games server) get the API origin; absolute URLs (platform media such as item
 * icons, `https://assets.swtorbit.com/i/...`) are used as they are.
 */
export function resolveServerUrl(url: string): string;
export function resolveServerUrl(url: string | null | undefined): string | undefined;
export function resolveServerUrl(url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  return /^https?:\/\//i.test(url) ? url : `${API_URL}${url}`;
}
